import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Copyright } from '@mui/icons-material';

export default function Footer() {
    const poppins = { fontFamily: "'Poppins', sans-serif" };

    return (
        <Box component="footer" sx={{
            py: 2, px: 2, bgcolor: '#ffffff',
            borderTop: '1px solid #E9EDF7', mt: 'auto', ...poppins
        }}>
            <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Copyright sx={{ fontSize: 16, color: '#A3AED0' }} />
                    <Typography variant="caption" sx={{ color: '#707EAE', fontWeight: 500 }}>
                        {new Date().getFullYear()} 237Showbiz Admin Center.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}